import { useParams } from "react-router";

import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import { clearAllLocFor } from "@/models/localForage/localForage.model";
import {
  isTokenExpired,
  refreshTokenCheckRedirect,
  requestAndSetTokens,
} from "@/utils/tokens.util";
import { useLayoutEffect } from "react";

const LoggingInPage = () => {
  const { jwt } = useParams();
  // if jwt and encoded is null or undefined or empty string, redirect to login
  useLayoutEffect(() => {
    if (!jwt) {
      console.log("No jwt found");
      window.location.href = ROUTE_LOGIN_OUT;
      return;
    }

    // Use the jwt to request refresh and auth and set it in local storage
    const fetchData = async () => {
      await clearAllLocFor();
      if (isTokenExpired(jwt) === false) {
        await requestAndSetTokens(jwt, true);
        // Once fetchMfaJWT is done and local storage is set, execute refreshTokenCheckRedirect
        refreshTokenCheckRedirect();
      } else {
        console.log("jwt is expired");
        window.location.href = ROUTE_LOGIN_OUT;
      }
    };
    fetchData();
  }, [jwt]);

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="border-primary flex h-10 w-10 animate-spin items-center justify-center rounded-full border-4 border-t-4 border-t-transparent"></div>
    </div>
  );
};

export default LoggingInPage;
